import React from 'react';

export default props => {
  return (
    <div style={styles.container}>
      <div style={{ fontSize: 16, fontWeight: 'bold', textAlign: 'center' }}>
        Debug Panel
      </div>
      <Label>URL:</Label>
      <Result>{props.url}</Result>
      <Label>X Percentage:</Label>
      <Result>{Math.round(props.percentage.x * 100) / 100}%</Result>
      <Label>Y Percentage:</Label>
      <Result>{Math.round(props.percentage.y * 100) / 100}%</Result>
    </div>
  );
};

const Label = props => <span style={styles.label}>{props.children} </span>;
const Result = props => (
  <span style={styles.result}>
    {props.children}
    <br />
  </span>
);
const styles = {
  container: {
    position: 'absolute',
    bottom: 10,
    left: 10,
    borderRadius: 6,
    display: 'inline-block',
    fontFamily: 'monospace',
    background: '#000000aa',
    padding: '5px',
    color: 'white'
  },
  label: {
    textDecoration: 'bold'
  },
  result: {
    color: '#34ffed'
  }
};



// WEBPACK FOOTER //
// ./src/components/DebugPanel.js